/* Offre bundle : 2e article à -X %. Ajoute les 2 articles en un seul appel /cart/add.js. */
if (!customElements.get('cro-bundle')) {
  class CroBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-bundle-json]').textContent);
      } catch (e) {
        console.error('cro-bundle: données invalides', e);
        return;
      }
      this.percent = Number(this.dataset.percent) || 20;
      this.formId = this.dataset.formId;
      this.mode = this.dataset.default === 'single' ? 'single' : 'bundle';
      this.offerIndex = 0;
      this.selected = [];
      this.userPickedSize = false;
      this.busy = false;
      this.offerArea = this.querySelector('[data-offer]');
      this.sizeArea = this.querySelector('[data-size-area]');
      this.errorEl = this.querySelector('[data-bundle-error]');

      this.querySelectorAll('[data-mode]').forEach(button =>
        button.addEventListener('click', () => this.setMode(button.dataset.mode))
      );
      this.querySelectorAll('[data-offer-index]').forEach(card =>
        card.addEventListener('click', () => this.selectOffer(Number(card.dataset.offerIndex), true))
      );
      this.sizeArea.addEventListener('click', event => this.onSizeClick(event));
      this.addEventListener('keydown', event => this.onKeydown(event));

      this.onFormChange = event => {
        const form = this.getForm();
        if (!form) return;
        if (event.target.form === form || form.contains(event.target) || this.closest('.product__content')?.contains(event.target)) {
          this.syncSizeWithMain();
          this.update();
        }
      };
      document.addEventListener('change', this.onFormChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.syncSizeWithMain();
          this.update();
        });
      }

      this.onSubmit = event => this.handleSubmit(event);
      document.addEventListener('submit', this.onSubmit, true);

      this.selectOffer(0, false);
      this.setMode(this.mode);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onFormChange);
      document.removeEventListener('submit', this.onSubmit, true);
      this.unsubscribe?.();
      this.ready = false;
    }

    getForm() {
      return document.getElementById(this.formId);
    }

    money(cents) {
      if (typeof window.formatPrice === 'function' && this.dataset.moneyFormat) {
        const html = window.formatPrice(cents, this.dataset.moneyFormat);
        return new DOMParser().parseFromString(html, 'text/html').body.textContent;
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR'
      }).format(cents / 100);
    }

    discounted(cents) {
      return Math.round((cents * (100 - this.percent)) / 100);
    }

    mainVariant() {
      const form = this.getForm();
      const id = Number(form?.querySelector('[name="id"]')?.value);
      return this.data.main.find(v => v.id === id) || this.data.main.find(v => v.available) || this.data.main[0];
    }

    mainQuantity() {
      const input = this.getForm()?.querySelector('[name="quantity"]') || document.querySelector(`[name="quantity"][form="${this.formId}"]`);
      const qty = parseInt(input?.value, 10);
      return qty > 0 ? qty : 1;
    }

    offer() {
      return this.data.offers[this.offerIndex];
    }

    offerVariant() {
      const offer = this.offer();
      if (!offer) return null;
      return offer.variants.find(v => v.options.every((value, i) => value === this.selected[i])) || null;
    }

    // Price shown before a size is chosen: first available variant of the selected product.
    offerDisplayPrice() {
      const offer = this.offer();
      const variant = this.offerVariant() || offer?.variants.find(v => v.available) || offer?.variants[0];
      return variant ? variant.price : 0;
    }

    canChoose(optionIndex, value) {
      const offer = this.offer();
      return offer.variants.some(
        v =>
          v.available &&
          v.options[optionIndex] === value &&
          this.selected.every((choice, i) => i >= optionIndex || choice === null || v.options[i] === choice)
      );
    }

    setMode(mode) {
      this.mode = mode === 'single' ? 'single' : 'bundle';
      this.querySelectorAll('[data-mode]').forEach(button =>
        button.setAttribute('aria-checked', String(button.dataset.mode === this.mode))
      );
      this.offerArea.hidden = this.mode !== 'bundle';
      this.closest('.product__content')?.classList.toggle('cro-bundle-mode', this.mode === 'bundle');
      this.showError('');
      this.update();
    }

    selectOffer(index, focus) {
      if (!this.data.offers[index]) return;
      this.offerIndex = index;
      this.userPickedSize = false;
      const offer = this.offer();
      this.selected = offer.options.map(() => null);
      if (offer.variants.length === 1 && offer.variants[0].available) this.selected = [...offer.variants[0].options];
      this.syncSizeWithMain();
      this.querySelectorAll('[data-offer-index]').forEach(card => {
        const active = Number(card.dataset.offerIndex) === index;
        card.setAttribute('aria-checked', String(active));
        card.tabIndex = active ? 0 : -1;
      });
      if (focus) this.querySelector(`[data-offer-index="${index}"]`)?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      this.renderSizes();
      this.showError('');
      this.update();
    }

    // Pre-select the same size as the main product when the customer hasn't chosen yet.
    syncSizeWithMain() {
      if (this.userPickedSize) return;
      const offer = this.offer();
      const main = this.mainVariant();
      const mainValues = main ? this.data.mainVariantOptions[String(main.id)] || [] : [];
      if (!offer) return;
      offer.options.forEach((name, i) => {
        const values = [...new Set(offer.variants.map(v => v.options[i]))];
        if (values.length === 1) {
          this.selected[i] = values[0];
          return;
        }
        const mainIndex = this.data.mainOptions.findIndex(n => String(n).toLowerCase() === String(name).toLowerCase());
        const candidate = mainIndex > -1 ? mainValues[mainIndex] : null;
        if (candidate && values.includes(candidate) && this.canChoose(i, candidate)) this.selected[i] = candidate;
        else if (this.selected[i] !== null && !this.canChoose(i, this.selected[i])) this.selected[i] = null;
      });
      this.refreshSizes();
    }

    renderSizes() {
      const offer = this.offer();
      this.sizeArea.replaceChildren();
      const groups = offer.options
        .map((name, i) => ({ name, i, values: [...new Set(offer.variants.map(v => v.options[i]))] }))
        .filter(group => group.values.length > 1);
      this.sizeArea.hidden = groups.length === 0;
      groups.forEach(group => {
        const label = document.createElement('p');
        label.className = 'cro-bundle__size-label';
        label.append(`${groups.length === 1 && this.dataset.sizeLabel ? this.dataset.sizeLabel : group.name} : `);
        const value = document.createElement('strong');
        value.dataset.sizeValue = group.i;
        label.append(value);
        const list = document.createElement('div');
        list.className = 'cro-options';
        list.setAttribute('role', 'group');
        list.setAttribute('aria-label', group.name);
        group.values.forEach(v => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cro-option';
          button.textContent = v;
          button.dataset.optionIndex = group.i;
          button.dataset.value = v;
          list.append(button);
        });
        this.sizeArea.append(label, list);
      });
      this.refreshSizes();
    }

    refreshSizes() {
      if (!this.sizeArea) return;
      this.sizeArea.querySelectorAll('[data-option-index]').forEach(button => {
        const i = Number(button.dataset.optionIndex);
        button.setAttribute('aria-pressed', String(this.selected[i] === button.dataset.value));
        button.disabled = this.busy || !this.canChoose(i, button.dataset.value);
      });
      this.sizeArea.querySelectorAll('[data-size-value]').forEach(el => {
        el.textContent = this.selected[Number(el.dataset.sizeValue)] || '—';
      });
    }

    onSizeClick(event) {
      const button = event.target.closest('[data-option-index]');
      if (!button || button.disabled || this.busy) return;
      const i = Number(button.dataset.optionIndex);
      this.selected[i] = button.dataset.value;
      for (let j = i + 1; j < this.selected.length; j++) {
        if (this.selected[j] !== null && !this.canChoose(j, this.selected[j])) this.selected[j] = null;
      }
      this.userPickedSize = true;
      this.showError('');
      this.refreshSizes();
      this.update();
    }

    onKeydown(event) {
      const radio = event.target.closest('[role="radio"]');
      if (!radio || !['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const group = [...radio.parentElement.querySelectorAll('[role="radio"]')];
      const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const next = group[(group.indexOf(radio) + step + group.length) % group.length];
      event.preventDefault();
      next.focus();
      next.click();
    }

    update() {
      const main = this.mainVariant();
      if (!main) return;
      const qty = this.mainQuantity();
      const mainTotal = main.price * qty;
      const offerPrice = this.offerDisplayPrice();
      const compare = mainTotal + offerPrice;
      const total = mainTotal + this.discounted(offerPrice);
      const set = (selector, text) => {
        const el = this.querySelector(selector);
        if (el) el.textContent = text;
      };
      set('[data-single-price]', this.money(mainTotal));
      set('[data-bundle-compare]', this.money(compare));
      set('[data-bundle-total]', this.money(total));
      set('[data-bundle-savings]', `${this.dataset.savingsLabel || 'Tu économises'} ${this.money(compare - total)}`);
      const card = this.querySelector(`[data-offer-index="${this.offerIndex}"]`);
      if (card) {
        card.querySelector('[data-card-compare]').textContent = this.money(offerPrice);
        card.querySelector('[data-card-price]').textContent = this.money(this.discounted(offerPrice));
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = !message;
    }

    async handleSubmit(event) {
      const form = this.getForm();
      if (this.mode !== 'bundle' || !form || event.target !== form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton?.getAttribute('aria-disabled') === 'true' || submitButton?.disabled) return;

      const mainId = Number(form.querySelector('[name="id"]')?.value);
      const offerVariant = this.offerVariant();
      if (!mainId) {
        this.showError('Choisis d’abord ta taille pour cet article.');
        return;
      }
      if (!offerVariant || !offerVariant.available) {
        this.showError('Choisis la taille de ton 2e article.');
        this.sizeArea.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.sizeArea.querySelector('.cro-option:not(:disabled)')?.focus({ preventScroll: true });
        return;
      }

      this.busy = true;
      this.showError('');
      this.refreshSizes();
      submitButton?.setAttribute('aria-disabled', 'true');
      submitButton?.classList.add('loading');
      submitButton?.querySelector('.loading__spinner')?.classList.remove('hidden');

      const bundleId = `B${Date.now().toString(36)}`;
      const label = `-${this.percent}% sur le 2e article`;
      const mainItem = { id: mainId, quantity: this.mainQuantity(), properties: { _bundle: bundleId } };
      const sellingPlan = form.querySelector('[name="selling_plan"]')?.value;
      if (sellingPlan) mainItem.selling_plan = sellingPlan;
      const offerItem = { id: offerVariant.id, quantity: 1, properties: { _bundle: bundleId, _bundle_offer: label } };

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.() || [];
      const sectionIds = [...new Set(sections.map(s => s.section))].slice(0, 5);
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const code = (this.dataset.code || '').trim();
        if (code) {
          await fetch(`${root}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
        }
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [mainItem, offerItem],
            ...(sectionIds.length ? { sections: sectionIds, sections_url: window.location.pathname } : {})
          })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(result.description || result.message || 'Le bundle n’a pas pu être ajouté. Réessaie.');
        }
        added = true;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cro-bundle', productVariantId: mainId, cartData: result });
        }
        const ready = sections.some(s => typeof result.sections?.[s.section] === 'string');
        if (!drawer || !ready) {
          window.location.assign(`${root}cart`);
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.setActiveElement?.(submitButton);
        drawer.renderContents(result, true);
        if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
        document.dispatchEvent(new CustomEvent('cro:bundle-added', { detail: { mainId, offerId: offerVariant.id } }));
      } catch (err) {
        if (added) {
          window.location.assign(`${root}cart`);
          return;
        }
        this.showError(err.message || 'Connexion interrompue. Vérifie ton panier avant de réessayer.');
      } finally {
        this.busy = false;
        this.refreshSizes();
        submitButton?.classList.remove('loading');
        submitButton?.removeAttribute('aria-disabled');
        submitButton?.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  }
  customElements.define('cro-bundle', CroBundle);
}
